/**
 * Created by alex on 2017/2/10.
 */

export const SET_USER = 'SET_USER' // 登录成功
export const USER_SIGNOUT = 'USER_SIGNOUT' // 退出登录
export const SET_ROLES = 'SET_ROLES'
export const SET_USER_AVATAR = 'SET_USER_AVATAR'
export const SET_TOKEN = 'SET_TOKEN'
export const SET_INFO = 'SET_INFO' // 获取信息
export const UNREAD_MESSAGE = 'UNREAD_MESSAGE' // 未读消息
export const UNREAD_NOTICE = 'UNREAD_NOTICE' // 未读通知

export const ACCESS_TOKEN = 'token'

export const SET_SYS_COUNT = 'SET_SYS_COUNT'
export const SET_NOTICE_NUM = 'SET_NOTICE_NUM'
export const SET_PAGE_TITLE = 'SET_PAGE_TITLE'
export const SET_WEIXIN_SHARE_DATA = 'SET_WEIXIN_SHARE_DATA'
export const SET_USER_COMPLETION = 'SET_USER_COMPLETION' // 用户信息完善程度

export const SET_THIS_ACTIVITY = 'SET_THIS_ACTIVITY'
export const SET_CACHE_DATA = 'SET_CACHE_DATA'

export const STUDENT = 'student'
export const COMPANY = 'company'
export const ANCHOR = 'anchor'
export const UNIVERSITY = 'university'
export const DEV = 'dev'

export const VIEW = 'VIEW'
export const CREATE = 'CREATE'
export const EDIT = 'EDIT'
export const DELETE = 'DELETE'
export const CHECK = 'CHECK'
export const SET_QUIZ = 'SET_QUIZ' // 考试状态记录



// WEBPACK FOOTER //
// ./src/common/utils/constant.js